import httpClient from "./httpClient";

export async function listarCampanhas() {
  const response = await httpClient.get("/api/campanhas-destaque");
  return Array.isArray(response.data) ? response.data : [];
}

// So as vigentes, ja com o progresso medido no periodo da campanha (nao no filtro da tela).
export async function listarCampanhasVigentes() {
  const response = await httpClient.get("/api/campanhas-destaque/vigentes");
  return Array.isArray(response.data) ? response.data : [];
}

export async function salvarCampanha(campanha) {
  const response = await httpClient.post("/api/campanhas-destaque", campanha);
  return response.data || {};
}

export async function removerCampanha(id) {
  await httpClient.delete(`/api/campanhas-destaque/${id}`);
}
